import React from 'react';
import moment from 'moment/moment';
import Tooltip from '@mui/material/Tooltip';
import { DateFormats } from 'constants/common';
import { ChecklistRtl, CopyAll, Edit } from '@mui/icons-material';
import { FormControlLabel, IconButton, Stack, Switch, Typography } from '@mui/material';

import { Template } from '../../api';
import type { ListSectionActions } from './ListSection';

export function createColumns(actions: ListSectionActions, isActiveStatusSetting: boolean) {
  return [
    {
      sortable: true,
      accessor: 'name',
      Header: 'Template Name',
      headerClassName: 'customHeader',
      Cell: ({ original }: { original: Template }) => <Typography>{original.name}</Typography>,
    },
    {
      sortable: true,
      accessor: 'name',
      Header: 'Created At',
      headerClassName: 'customHeader',
      Cell: ({ original }: { original: Template }) => (
        <Typography>{moment(Number(original.createdDateTime)).format(DateFormats.DateTimeMedium24Hour)}</Typography>
      ),
    },
    {
      sortable: true,
      accessor: 'name',
      Header: 'Last Updated',
      headerClassName: 'customHeader',
      Cell: ({ original }: { original: Template }) => (
        <Typography>
          {original.modifiedDateTime
            ? moment(Number(original.modifiedDateTime)).format(DateFormats.DateTimeMedium24Hour)
            : moment(Number(original.createdDateTime)).format(DateFormats.DateTimeMedium24Hour)}
        </Typography>
      ),
    },
    {
      accessor: '',
      sortable: false,
      Header: 'Action',
      headerClassName: 'customHeader',
      Cell: ({ original }: { original: Template }) => (
        <Stack direction="row" gap="0.5rem" paddingLeft="0.5rem">
          <FormControlLabel
            label="Active"
            control={
              <Switch
                size="small"
                checked={original.isActive}
                disabled={isActiveStatusSetting}
                onChange={async _ => {
                  await actions.onSetActiveStatus(original.businessProcessFlowId);
                }}
              />
            }
          />

          <Tooltip title="Copy template">
            <IconButton
              className="icon-btn-bordered"
              onClick={() => {
                actions.onCopyTemplate(original.businessProcessFlowId);
              }}
            >
              <CopyAll color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Close reasons">
            <IconButton
              className="icon-btn-bordered"
              onClick={() => {
                actions.onRedirectToCloseReasons(original.businessProcessFlowId);
              }}
            >
              <ChecklistRtl color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Edit template">
            <IconButton
              className="icon-btn-bordered"
              onClick={async () => {
                await actions.onEditTemplate(original.businessProcessFlowId);
              }}
            >
              <Edit color="primary" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];
}
